<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"padding-bottom:200px;"' class="container " >
                <template #default>   <m-section-200 v-bind='{...{"imageBefore":"https:\/\/api.arair.ir\/storage\/\u0628\u0644\u0641\u0627\u0631\u0648\u067e\u0644\u0627\u0633\u062a\u06cc\/Untitled-159.jpg","imageAfter":"https:\/\/api.arair.ir\/storage\/\u0628\u0644\u0641\u0627\u0631\u0648\u067e\u0644\u0627\u0633\u062a\u06cc\/Untitled-1578.jpg","direction":"horizontal"},...{}}' :style='""' class="col-12 mx-auto text-center mb-4" >
                <template #after-1>   </template>
                
                <template #before-1>   </template>
                </m-section-200></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mSection200 from '@moeinmdn/miw-alpha-components/src/package/Sections/Section200';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mSection200 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
